import React, { useEffect, useState } from "react";
import {
  Box,
  IconButton,
  MenuItem,
  Paper,
  Switch,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TablePagination,
  TextField,
  Chip,
  Typography,
  Button,
} from "@mui/material";
import { Edit, Delete, Visibility } from "@mui/icons-material";
import apiClient from "../utils/apiClient";
import { toast } from "react-toastify";
import ConfirmDialog from "../components/ConfirmDialog";
import FallbackImage from "../components/FallbackImage";
import { getImageFullUrl, pageRoute } from "../utils/common";
import { useNavigate } from "react-router-dom";
import ListAltIcon from "@mui/icons-material/ListAlt";

const VendorListPage = () => {
  const [products, setProducts] = useState([]);
  const [categories, setCategories] = useState([]);

  const [search, setSearch] = useState("");
  const [statusFilter, setStatusFilter] = useState("");
  const [isVerifyFilter, setIsVerifyFilter] = useState("");
  const [isSubmittedFilter, setIsSubmittedFilter] = useState("");
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [totalCount, setTotalCount] = useState(0);
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate()

  const pageChange = (url) => {
    navigate(url)
  }

  // Fetch products
  const fetchProducts = async () => {
    try {
      setLoading(true);
      const res = await apiClient.get("/api/admin/vendor", {
        params: {
          search,
          status: statusFilter,
          isVerify: parseInt(isVerifyFilter),
          is_submitted: parseInt(isSubmittedFilter),
          page: page + 1, // backend usually 1-based
          limit: rowsPerPage,
        },
      });

      setProducts(res?.data?.data?.vendors || []);
      setTotalCount(res?.data?.data?.total || 0);
    } catch (err) {
      toast.error("Failed to load vendor");
    } finally {
      setLoading(false);
    }
  };

  // Refetch when filters/search/page/rowsPerPage change
  useEffect(() => {
    fetchProducts();
  }, [search, statusFilter, page, rowsPerPage, isVerifyFilter, isSubmittedFilter]);

  // Toggle status
  const handleStatusChange = async (id, newStatus) => {
    try {
      await apiClient.put(`/api/admin/vendor/${id}`, { status: newStatus });
      toast.success("Status updated");
      fetchProducts();
    } catch {
      toast.error("Failed to update status");
    }
  };

  const handleIsVerifyChange = async (id, newStatus) => {
    try {
      await apiClient.put(`/api/admin/vendor/${id}`, { isVerify: newStatus });
      toast.success("Verify status updated");
      fetchProducts();
    } catch {
      toast.error("Failed to update verify status");
    }
  };

  return (
    <Paper sx={{ p: 3 }}>
      <Box sx={{ display: "flex", gap: 2, mb: 2, flexWrap: "wrap", alignItems: 'center', justifyContent: 'space-between' }}>
        <Typography variant="h5" gutterBottom>
          Vendor List
        </Typography>

      </Box>
      {/* Search & Filters */}
      <Box sx={{ display: "flex", gap: 2, mb: 2, flexWrap: "wrap" }}>
        <TextField
          label="Search"
          size="small"
          value={search}
          onChange={(e) => {
            setPage(0); // reset page
            setSearch(e.target.value);
          }}
        />
        <TextField
          select
          size="small"
          label="Filter by Status"
          value={statusFilter}
          onChange={(e) => {
            setPage(0);
            setStatusFilter(e.target.value);
          }}
          sx={{ width: 200 }}
        >
          <MenuItem value="">All</MenuItem>
          <MenuItem value="active">Active</MenuItem>
          <MenuItem value="inactive">Inactive</MenuItem>
        </TextField>
        <TextField
          select
          size="small"
          label="Filter by Verify"
          value={isVerifyFilter}
          onChange={(e) => {
            setPage(0);
            setIsVerifyFilter(e.target.value);
          }}
          sx={{ width: 200 }}
        >
          <MenuItem value="">All</MenuItem>
          <MenuItem value="1">Verify</MenuItem>
          <MenuItem value="0">Not Verify</MenuItem>
        </TextField>
        {/* <TextField
          select
          size="small"
          label="Filter by Submitted"
          value={isSubmittedFilter}
          onChange={(e) => {
            setPage(0);
            setIsSubmittedFilter(e.target.value);
          }}
          sx={{ width: 200 }}
        >
          <MenuItem value="">All</MenuItem>
          <MenuItem value="1">Submitted</MenuItem>
          <MenuItem value="0">Not Submitted</MenuItem>
        </TextField> */}
      </Box>

      {/* Table */}
      <TableContainer>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Avatar</TableCell>
              <TableCell> Name</TableCell>
              <TableCell>Email</TableCell>
              <TableCell>Mobile</TableCell>
              <TableCell>Verify</TableCell>
              <TableCell>Status</TableCell>
              <TableCell>Submit</TableCell>
              <TableCell>Details</TableCell>
            </TableRow>
          </TableHead>

          <TableBody>
            {products.length > 0 ? (
              products.map((row) => (
                <TableRow key={row.id}>
                  <TableCell><FallbackImage
                    src={getImageFullUrl(row.avatar)}
                    style={{ maxHeight: '50px' }}
                  /></TableCell>
                  <TableCell>{row.name}</TableCell>
                  <TableCell>{row.email}</TableCell>
                  <TableCell>{row.mobile}</TableCell>

                  <TableCell>
                    <Switch
                      checked={row.isVerify}
                      onChange={(e) =>
                        handleIsVerifyChange(
                          row.id,
                          e.target.checked
                        )
                      }
                    />
                  </TableCell>
                  <TableCell>
                    <Switch
                      checked={row.status === "active"}
                      onChange={(e) =>
                        handleStatusChange(
                          row.id,
                          e.target.checked ? "active" : "inactive"
                        )
                      }
                    />
                  </TableCell>
                  <TableCell align="center">
                    <Chip
                      size="small"
                      color={row?.businessDetails?.is_submitted ? "success" : "warning"}
                      variant="outlined"
                      label={row?.businessDetails?.is_submitted ? "Submitted" : "Not Submit"}
                      sx={{ fontWeight: 700, fontSize: 10 }}
                    />
                  </TableCell>
                  <TableCell align="center">
                    <IconButton
                      color="primary"
                      onClick={() => pageChange(pageRoute.vendorView + row.id)}
                    >
                      <Visibility />
                    </IconButton>
                    <IconButton
                      color="secondary"
                      onClick={() => pageChange(pageRoute.productList + '?id=' + row.id)}
                    >
                      <ListAltIcon />
                    </IconButton>
                   
                  </TableCell>
                </TableRow>
              ))
            ) : (
              <TableRow>
                <TableCell colSpan={8} align="center">
                  {loading ? "Loading..." : "No vendor found"}
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>

      {/* Pagination */}
      <TablePagination
        component="div"
        count={totalCount}
        page={page}
        onPageChange={(e, newPage) => setPage(newPage)}
        rowsPerPage={rowsPerPage}
        onRowsPerPageChange={(e) => {
          setRowsPerPage(parseInt(e.target.value, 10));
          setPage(0);
        }}
        rowsPerPageOptions={[5, 10, 20]}
      />
    </Paper>
  );
};

export default VendorListPage;
